import React, { Component } from 'react'
import { Grid } from 'react-bootstrap';
import { withRouter } from 'react-router';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { InfoBox, Uppercase } from '../components/OnePager/OnePageStyle'

import { NavSpacer } from '../components/GeneralStyle'
import PartnerGrid from '../components/partner/PartnerGrid'

import styled from 'styled-components'
import './Industry.css'
import breadCrumbArrow from '../images/breadcrumb_arrow.png'

@inject('partnerInformationStore')
@observer
class Industry extends Component {

  render() {
    const industry = this.props.partnerInformationStore.getIndustryFromSlug(this.props.match.params.slug)

    return (
      <Grid fluid>
        <div className="pageWrapper" style={{marginTop: '60px', background: '#f5f5f5'}}>
          <NavSpacer />
          <HeroContainer>
            <IndustryImage src={industry && industry.image}></IndustryImage>
            <InfoBox className='content-wrapper industry-description' style={{marginLeft: '0'}}>
              <div className="breadcrumbs">
                <img src={breadCrumbArrow}  onClick={() => {this.props.history.push("/partners/")}} />
                <div className="path">
                  <span onClick={() => {this.props.history.push("/partners/")}}>Branchen</span> / <span style={{textDecoration: 'underline'}}>{industry && industry.name}</span>
                </div>
              </div>
              <h1 className="industry-title">{industry && industry.name}</h1>
              <p>
              {industry && industry.text}
              </p>
            </InfoBox>
          </HeroContainer>
          { industry && <PartnerGrid industry={ industry }/>}
        </div>
      </Grid>
    )
  }
}

const IndustryImage = styled.img`
  position: absolute;
  width: 50%;
  height: 100%;
  top: 0;
  right: 0;
  object-fit: cover;

  @media (max-width: 768px){
    position: relative;
    height: 15vh;
    width: 100%;
  }
`
const HeroContainer = styled.div`
  display: flex;
  align-items: center;
  background: linear-gradient(131.45deg, rgba(255, 255, 255, 0.5) -17.18%, rgba(255, 255, 255, 0) 57.6%), #DAB777;
  position: relative;

  @media (max-width: 768px){
    flex-wrap: wrap;
    padding-bottom: 100px;
  }
`

export default withRouter(Industry);



// WEBPACK FOOTER //
// /src/pages/Industry.js